import { Validate } from "../util";
import { BaseConfig } from "../config.interface";

interface ITimePickerConfig {
    label?: string;
    asDuration?: boolean;
    asTimespan?: boolean;
    showClear?: boolean;
    validate: Validate;
}
export class TimePickerConfig extends BaseConfig<ITimePickerConfig> implements ITimePickerConfig {
    /**
     * Label of the element.
     */
    label?: string;
    /**
     * Durations allow time spans exceeding 24 hours.
     * If false the time picker will be limited to 24 hours.
     */
    asDuration?: boolean;
    /**
     * If true, the value will be treated and returned as a timespan (Duration) instead of a time of day. (allows values > 24 hours)
     */
    asTimespan?: boolean;
    showClear?: boolean;
    /**
     * Show validation status already in `pristine` state or after it has been marked as `dirty`.
     */
    validate: Validate;

    /**
     * @theme Base
     */
    static baseTheme = {
        /**
         * Default configuration.
         */
        Default: new TimePickerConfig({
            showClear: true,
            validate:  "dirty",
        }),

        /**
         * Display input element as label.
         * 
         */
        Duration: new TimePickerConfig({
            asDuration: true,
            asTimespan: true,
            showClear:  true,
            validate:   "dirty",
        }),

        DayTime: new TimePickerConfig({
            asDuration: true,
            asTimespan: false,
            showClear:  true,
            validate:   "dirty",
        }),
   };

}